/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { WHITELIST_DELEGATE } from "../graphql/delegateWhiteList.mutation";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface DelegateWhiteListProps {
  email: string;
}
export interface IDelegateWhiteListMethods extends IPluginMethodMap {
  getDelegateWhiteList(args: DelegateWhiteListProps): Promise<any>;
}

export class DelegateWhiteListService implements IAgentPlugin {
  readonly methods: IDelegateWhiteListMethods;

  constructor() {
    this.methods = {
      getDelegateWhiteList: this.getDelegateWhiteList.bind(this),
    };
  }

  async getDelegateWhiteList(args: DelegateWhiteListProps) {
    log.blue(`DelegateWhiteList server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: WHITELIST_DELEGATE,
          variables: {
            costumeId: args,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.whiteListDelegate,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
